import { turboproApiLista } from '@/api/turbopro';
import type { DadosRelatorioItem, ListarDadosFiltros, ListarDadosResponse } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarDadosApi(filtros: ListarDadosFiltros): Promise<ListarDadosResponse> {
  const params = new URLSearchParams({
    agendamento_id: filtros.agendamentoId.toString(),
  });

  const resposta = await turboproApiLista<DadosRelatorioItem>(
    `Relatorios/ListarDados?${params.toString()}`,
    { headers: getRelatoriosHeaders() }
  );
  return resposta.data ?? [];
}
